export default __webpack_public_path__ + "static/brush-home-54f7fef08493e8e678e4d52c95f2627b.png";